
class ShortLoadingAnimation {
  constructor () {
    this.shortLoading = document.createElement('div')
    this.runningFlag = false
    this.created = false
  }

  create () {
    if (this.created) return
    this.shortLoading.classList.add('short-loading')
    const randNameArr = ['shiro','goma','nju']
    this.shortLoading.innerHTML = `<svg class="short-loading__svg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 2000 2000">
        <use href="#svg-${randNameArr[Math.floor( Math.random() * 3 )]}" fill="#ccc"></use>
      </svg>`

    this.created = true
  }

  svgCreate () {
    if (this.created) return

    this.shortLoading.classList.add('short-loading', 'short-loading--top')
    this.shortLoading.innerHTML = `<svg class="svg-logo" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 2000 2000">
        <line class="svg-logo__leln-1" x1="1000" y1="1100" x2="1000" y2="1500" stroke="#ccc" stroke-miterlimit="10" stroke-width="80"/>
        <polygon class="svg-logo__polygon-1" points="1000 1100 800 1300 1200 1300 1000 1100"/>
        <line class="svg-logo__leln-2" x1="1000" y1="900" x2="1000" y2="500" fill="none" stroke-miterlimit="10" stroke-width="80"/>
        <polygon class="svg-logo__polygon-2" points="1000 900 800 700 1200 700 1000 900"/>
        <g class="svg-logo__path-1">
          <polygon class="path-poly" points="1425.86 1564.14 1425.86 1505.86 1000 1080 574.14 1505.86 574.14 1564.14 385.86 1564.14 385.86 1494.14 880 1000 385.86 505.86 385.86 435.86 574.14 435.86 574.14 494.14 1000 920 1425.86 494.14 1425.86 435.86 1614.14 435.86 1614.14 505.86 1120 1000 1614.14 1494.14 1614.14 1564.14 1425.86 1564.14"/>
          <path class="svg-logo__path-bg" d="M1600,450v50l-500,500,500,500v50H1440v-50l-440-440L560,1500v50H400v-50l500-500L400,500V450H560v50l440,440,440-440V450h160m28.28-28.28H1411.72v66.56L1000,900,588.28,488.28V421.72H371.72v90L380,520l480,480L380,1480l-8.28,8.29v90H588.28v-66.56L1000,1100l411.72,411.72v66.56h216.56v-90L1620,1480l-480-480,480-480,8.28-8.29v-90Z"/>
        </g>
        <rect class="svg-logo__wiln-2" x="400" y="400" width="1200" height="100"/>
        <rect class="svg-logo__wiln-1" x="400" y="1500" width="1200" height="100"/>
        <circle class="svg-logo__border" cx="1000" cy="1000" stroke-width="50" r="1200" fill="transparent" />
      </svg>`
    this.created = true
  }

  start (dom = '') {
    this.create()
    if (this.runningFlag) {
      return false
    } else {
      this.runningFlag = true
    }
    this.targetDOM = dom === '' ? document.body : dom

    const tmpDom = this.targetDOM.querySelector('.short-loading')
    if (tmpDom) {
      this.targetDOM.removeChild(tmpDom)
    }
    this.targetDOM.appendChild(this.shortLoading)
    new Promise(res => {
      setTimeout(res, 10)
    })
      .then(() => {
        this.shortLoading.classList.add('short-loading--visible')
      })
  }

  end () {
    if (!this.runningFlag) {
      return setTimeout(() => {
        this.end()
      }, 500)
    } else {
      this.runningFlag = false
    }
    this.shortLoading.classList.remove('short-loading--visible')
    new Promise(res => {
      setTimeout(res, 264)
    })
      .then(() => {
        const tmpDom = this.targetDOM.querySelector('.short-loading')
        if (tmpDom) {
          this.targetDOM.removeChild(tmpDom)
        }
        return true
      })
  }
}

module.exports = ShortLoadingAnimation
